import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import NoItemResult from '../../../../components/results/NoItemResult';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import { type OpenRemoteFPSettingDrawer } from './RemoteFPSettingDrawer';

export type RemoteFPSettingEmptyListProps = {
    openDrawer: OpenRemoteFPSettingDrawer;
    permissions: Pick<PermissionValues, 'hasUpdatePermission'>;
};

const RemoteFPSettingEmptyList = ({ openDrawer, permissions }: RemoteFPSettingEmptyListProps) => {
    const { t } = useTranslation(['bankModuleDetails']);
    const { hasUpdatePermission } = permissions;

    return (
        <NoItemResult
            extra={
                hasUpdatePermission && (
                    <Button
                        onClick={() => {
                            openDrawer();
                        }}
                        type="primary"
                    >
                        {t('bankModuleDetails:remoteFpSetting.emptyList.noData.action')}
                    </Button>
                )
            }
            subTitle={t('bankModuleDetails:remoteFpSetting.emptyList.noData.message')}
        />
    );
};

export default RemoteFPSettingEmptyList;
